export type CacheAgeColor = 'secondary' | 'warning' | 'danger';

export const CACHE_AGE_COLORS = {
    SECONDARY: 'secondary' as CacheAgeColor,
    WARNING: 'warning' as CacheAgeColor,
    DANGER: 'danger' as CacheAgeColor,
} as const;

export const DEFAULT_AGE_OLD_MINUTES = 5;
export const DEFAULT_AGE_TOO_OLD_MINUTES = 15;

export function getCacheAgeColor(
    cachedAt: string | null,
    ageOld: number = DEFAULT_AGE_OLD_MINUTES,
    ageTooOld: number = DEFAULT_AGE_TOO_OLD_MINUTES,
): CacheAgeColor {
    if (!cachedAt) return 'secondary';
    const ageMinutes = (Date.now() - new Date(cachedAt).getTime()) / 60000;
    if (ageMinutes < ageOld) return 'secondary';
    if (ageMinutes < ageTooOld) return 'warning';
    return 'danger';
}
